import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=020a9374&"
import script from "./overlay.vue?vue&type=script&lang=js&"
export * from "./overlay.vue?vue&type=script&lang=js&"
import style0 from "./overlay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports